import { HttpClient } from "@angular/common/http";
import { environment as env } from "../../../../../environments/environment.prod";
import { Injectable } from "@angular/core";
import { AbstractService } from "app/services/abstract.service";
import { Observable } from "rxjs";
import {
  IPagination,
  IPaginationResult,
  IRequestResult,
} from "app/common/interfaces";
import {
  andAllWhere,
  andWhere,
  buildQuery,
  CombinedFilter,
  noop,
  Ops,
  orderBy,
  OrderVariant,
  orWhere,
  page,
  select,
  where,
} from "@albatrosdeveloper/ave-utils-npm/lib/utils/query.util";
import { ICreateGroupNotification, IUpdateGroupNotification } from "./interfaces/group-interface";
import ShortNotificationMemberAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/configurations/notification/notification-member/short-notification-member/short-notification-member.short.entity";
import { IFilters } from "../../filters/interfaces/filterInterface";
import NotificationGroupAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/configurations/notification/notification-group/notification-group.entity";

const apiUrl = env.API_AVE_NOTIFICATION;
const moduleName = "notification_group";

@Injectable({
  providedIn: "root",
})
export class GroupNotificationService extends AbstractService<
  NotificationGroupAttributes,
  ICreateGroupNotification,
  IUpdateGroupNotification
> {

  constructor(http: HttpClient) {
    super(apiUrl, moduleName, http);
  }

  /**
   * List
   * @param filter CombinedFilter of related entity - NotificationGroupAttributes
   * @returns Data list
   */
  getAllPaginate(
    options: IPagination<any>,
    dataToFilter?: IFilters
  ): Observable<IPaginationResult<any>> {
    const query = buildQuery<any>(
      where("_deleted", Ops.eq(false)),
      orderBy(
        options.sort ?? "name",
        options.sortDirection == "ASC" ? OrderVariant.Asc : OrderVariant.Desc
      ),
      dataToFilter.salesOfficeId?.length ? andAllWhere('salesOffice.id', Ops.in(...dataToFilter.salesOfficeId)) : noop(),
      dataToFilter && dataToFilter.companyId ? andAllWhere('company.id', Ops.eq(dataToFilter.companyId)) : noop(),
      //dataToFilter.companyId ? andAllWhere('company.id', Ops.eq(dataToFilter.companyId)) : noop(),
      dataToFilter.salesOfficeId && dataToFilter.salesOfficeId.length > 0 ? andAllWhere('salesOffice.id', Ops.in(...dataToFilter.salesOfficeId)) : noop(),
      dataToFilter.distributionChainId && dataToFilter.distributionChainId.length > 0 ? andAllWhere('distributionChain.id', Ops.in(...dataToFilter.distributionChainId)) : noop(),
      dataToFilter.status && dataToFilter.status.length > 0 ? andAllWhere('statusId', Ops.in(...dataToFilter.status)) : noop(),
      dataToFilter && dataToFilter?.notificationMemberId?.length ? where("members.id", Ops.in(...dataToFilter?.notificationMemberId)) : noop(),
      dataToFilter.status && dataToFilter.status.length > 0 ? andAllWhere('statusId', Ops.in(...dataToFilter.status)) : noop(),
      page(options.currentPage ?? 1, options.limitPerPage ?? 100)
    );

    const API_URL: string =
      apiUrl +
      `api/${moduleName}/withCount?filter=${encodeURIComponent(JSON.stringify(query))}`;
    return this.http.get<IPaginationResult<any>>(API_URL);
  }
  

  getMembersByGroupId(nGroupId: string): Observable<IRequestResult<ShortNotificationMemberAttributes[]>> {
    const API_URL: string =
      apiUrl +
      `api/${moduleName}/get_members/${nGroupId}`;
    return this.http.get<IRequestResult<ShortNotificationMemberAttributes[]>>(API_URL);
  }


  
}

